/* eslint-disable react/require-default-props */
import React from 'react';
import PropTypes from 'prop-types';

export default function SpreadsheetIcon({
  width = 40,
  height = 40,
}) {
  return (
    <svg width={width} height={height} viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M8 0.75H24C24.1212 0.75 24.2375 0.798088 24.3232 0.883789L35.1162 11.6768C35.2019 11.7625 35.25 11.8788 35.25 12V36C35.25 37.7949 33.7949 39.25 32 39.25H8C6.20507 39.25 4.75 37.7949 4.75 36V4C4.75 2.20507 6.20508 0.75 8 0.75Z" fill="white" stroke="#D0D5DD" strokeWidth="1.5" />
      <path d="M24 0.5V8C24 10.2091 25.7909 12 28 12H35.5" stroke="#D0D5DD" strokeWidth="1.5" />
      <path d="M11.8999 24.9H28.0999M11.8999 24.9V21.3C11.8999 20.3059 12.7058 19.5 13.6999 19.5H17.2999M11.8999 24.9V28.5C11.8999 29.4941 12.7058 30.3 13.6999 30.3H17.2999M28.0999 24.9V28.5C28.0999 29.4941 27.294 30.3 26.2999 30.3H17.2999M28.0999 24.9V21.3C28.0999 20.3059 27.294 19.5 26.2999 19.5H17.2999M17.2999 19.5V30.3" stroke="#099250" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  );
}

SpreadsheetIcon.propTypes = {
  width: PropTypes.number,
  height: PropTypes.number,
};
